import React, { useContext, useEffect, useState } from "react";
import ServiceWrapper from "../../../Services/ServiceWrapper";
import AuthManager from "../../../Common/AuthManager";
import AppSettings from "../../../Settings/AppSettings";
import { AppContext } from "../../../Context/AppContext";
import { useNavigate } from "react-router";
import GMSFillButton from "../../Common/components/GMSFillButton";
import { toast } from "Components/DesignSystem/Toast/useToast";
const CachePromotionView = () => {
  const [disableButton, setDisableButton] = useState(false);
  const [loaded, setloaded] = useState(false);
  let api_base_url = AppSettings.GMS_BACKEND_API_URL;
  const appData = useContext(AppContext);
  const navigate = useNavigate();
  useEffect(() => {
    if (!appData.pm.checkPermission("gmscache_edit")) {
      navigate("/workspace/module/permission/denied");
    } else {
      setloaded(true);
    }
  }, []); // eslint-disable-line
  const triggerCacheRefresh = async () => {
    setDisableButton(true);
    let res = await ServiceWrapper.doGet(
      api_base_url + "masterdata/generate",
      null,
      null,
      AuthManager.getGmsToken()
    );
    if (!res.errorfound && res?.data) {
      toast.info(
        "Triggered successfully, the button will be locked for next 7 minutes."
      );
      setTimeout(() => {
        setDisableButton(false);
      }, 420000);
    } else {
      toast.error("Error Occurred");
      setDisableButton(false);
    }
  };
  return (
    <>
      {loaded && (
        <div className="border-bottom" data-testid="admin-cache-page">
          <div className="pt-2 pb-2 d-flex justify-content-between ps-4 pe-3">
            <label
              className="fs-5 fw-bolder"
              data-testid="admin-cache-title"
              style={{
                fontFamily: "Noto Sans",
              }}
            >
              Cache Management
            </label>
            <GMSFillButton
              name="Trigger Cache"
              data-testid="admin-cache-trigger-btn"
              disabled={disableButton}
              onClick={() => {
                triggerCacheRefresh();
              }}
            />
          </div>
        </div>
      )}
    </>
  );
};
export default CachePromotionView;